/* Cinta infinita de marcas: gira sola, se puede arrastrar y da la vuelta sin fin. */
if (!customElements.get('home-brands-marquee')) {
  class HomeBrandsMarquee extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.track = this.querySelector('.home-brands__track');
      if (!this.track || !this.track.children.length) return;
      // Con "reducir movimiento" se queda como lista con scroll horizontal normal
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.initialized = true;
      this.originals = Array.from(this.track.children);
      this.x = 0;
      this.vel = 0;
      this.moved = 0;
      this.last = 0;
      this.paused = false;
      this.dragging = false;
      this.visible = true;
      this.setWidth = 0;
      this.speed = 38;
      this.classList.add('is-live');

      this.tick = this.tick.bind(this);
      this.build();
      this.bindEvents();

      this.ro = new ResizeObserver(() => this.build());
      this.ro.observe(this);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.build());

      this.io = new IntersectionObserver((entries) => {
        this.visible = entries[0].isIntersecting;
      });
      this.io.observe(this);

      this.raf = requestAnimationFrame(this.tick);
    }

    disconnectedCallback() {
      if (!this.initialized) return;
      this.initialized = false;
      cancelAnimationFrame(this.raf);
      this.ro && this.ro.disconnect();
      this.io && this.io.disconnect();
    }

    build() {
      this.track.querySelectorAll('[data-clone]').forEach((n) => n.remove());
      this.setWidth = this.track.scrollWidth;
      if (!this.setWidth) return;

      const copies = Math.max(1, Math.ceil(this.clientWidth / this.setWidth));
      for (let c = 0; c < copies; c++) {
        this.originals.forEach((item) => {
          const clone = item.cloneNode(true);
          clone.setAttribute('data-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
          this.track.appendChild(clone);
        });
      }

      this.speed = window.innerWidth >= 750 ? 50 : 38;
      this.wrap();
      this.apply();
    }

    wrap() {
      const w = this.setWidth;
      if (!w) return;
      this.x = ((this.x % w) - w) % w;
    }

    apply() {
      this.track.style.transform = 'translate3d(' + this.x + 'px, 0, 0)';
    }

    tick(now) {
      const dt = this.last ? Math.min(now - this.last, 64) : 16;
      this.last = now;

      if (!this.dragging) {
        if (Math.abs(this.vel) > 0.05) {
          // inercia despues de soltar
          this.x += this.vel;
          this.vel *= 0.94;
        } else if (!this.paused && this.visible && !document.hidden) {
          this.x -= (this.speed * dt) / 1000;
        }
        this.wrap();
        this.apply();
      }

      this.raf = requestAnimationFrame(this.tick);
    }

    bindEvents() {
      this.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        this.dragging = true;
        this.moved = 0;
        this.vel = 0;
        this.lastX = e.clientX;
        this.pointerId = e.pointerId;
        this.captured = false;
        this.classList.add('is-dragging');
      });

      this.addEventListener('pointermove', (e) => {
        if (!this.dragging) return;
        const dx = e.clientX - this.lastX;
        this.lastX = e.clientX;
        this.moved += Math.abs(dx);
        // Solo capturamos el puntero cuando ya es un arrastre, para no romper los toques en los links
        if (!this.captured && this.moved > 6) {
          this.captured = true;
          try {
            this.setPointerCapture(this.pointerId);
          } catch (err) {}
        }
        this.x += dx;
        this.vel = dx;
        this.wrap();
        this.apply();
      });

      const end = () => {
        if (!this.dragging) return;
        this.dragging = false;
        this.classList.remove('is-dragging');
        try {
          if (this.captured) this.releasePointerCapture(this.pointerId);
        } catch (err) {}
      };
      this.addEventListener('pointerup', end);
      this.addEventListener('pointercancel', end);

      // Si fue un arrastre, no abrir el link
      this.addEventListener(
        'click',
        (e) => {
          if (this.moved > 6) {
            e.preventDefault();
            e.stopPropagation();
            this.moved = 0;
          }
        },
        true
      );

      this.addEventListener('mouseenter', () => (this.paused = true));
      this.addEventListener('mouseleave', () => (this.paused = false));
      this.addEventListener('focusin', () => (this.paused = true));
      this.addEventListener('focusout', () => (this.paused = false));
    }
  }

  customElements.define('home-brands-marquee', HomeBrandsMarquee);
}